import { useRef } from "react";

export const useLatestRef = <T,>(v: T) => {
  const ref = useRef(v);
  ref.current = v;
  return ref;
}